import { render, staticRenderFns } from "./LiveOrder.vue?vue&type=template&id=66191df2&scoped=true"
import script from "./LiveOrder.vue?vue&type=script&lang=js"
export * from "./LiveOrder.vue?vue&type=script&lang=js"
import style0 from "./LiveOrder.vue?vue&type=style&index=0&id=66191df2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66191df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66191df2')) {
      api.createRecord('66191df2', component.options)
    } else {
      api.reload('66191df2', component.options)
    }
    module.hot.accept("./LiveOrder.vue?vue&type=template&id=66191df2&scoped=true", function () {
      api.rerender('66191df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/LiveOrder/LiveOrder.vue"
export default component.exports